import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";
import useTranslation from "next-translate/useTranslation";
import { useMemo } from "react";

export const Theme = ({ children }) => {
  const { lang } = useTranslation();
  const theme = useMemo(() => {
    return responsiveFontSizes(
      createTheme({
        overrides: {
          MuiInput: {
            input: {
              "&::placeholder": {
                color: "gray",
              },
              color: "white",
            },
          },
        },
        components: {
          MuiTextField: {
            defaultProps: {
              color: "secondary",
            },
          },
        },
        direction: lang === "ar" ? "rtl" : "ltr",
        palette: {
          primary: {
            main: "#0366FF",
            dark: "#011291",
          },
          secondary: {
            main: "#F8FBFF",
            contrastText: "#fff",
          },
        },
        typography: {
          fontFamily: "Expo_med",
          h3: {
            lineHeight: 1.5,
          },
          h5: {
            lineHeight: 1.38,
          },
        },
        breakpoints: {
          values: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
          },
        },

        spacing: (factor) => `${0.25 * factor}rem`,
      })
    );
  }, [lang]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
